import { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { QuestionAnswer } from "@mui/icons-material";
import "../../CampaignManagement.scss";
import { useTranslation } from "react-i18next";


export const ConfirmationDialog: FC<any> = ({
    open,
    title,
    description,
    onConfirm,
    onCancel,
  }) => {
    
    const { t } = useTranslation();

    const handleConfirm = () => {
      onConfirm();
    };

    const handleCancel = () => {
      if (onCancel != undefined) {
        onCancel();
      }
    };

    return (
      <>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description" style={{display:"flex"}}>
              <QuestionAnswer style={{ fontSize: 24, color: "#0d6efd", margin: "0 12px 0 0" }} />
              <Typography gutterBottom>
                {description}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel}>{t("campaignManagement.save.step.dialog.action.cancelButton")}</Button>
            <Button onClick={handleConfirm} autoFocus>
              {t("campaignManagement.save.step.dialog.action.okButton")}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };